import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/constants/images";

export default function FinalCTA() {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden py-24" data-testid="final-cta-section">
      <img src={IMAGES.madinahNight} alt="Madinah" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#084C3A]/95 to-[#0B4F71]/90" />
      <div className="relative mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <h2 className="font-heading text-3xl font-bold text-white sm:text-4xl">
          Mari Persiapkan Ibadah Anda Bersama KBIHU Muhammadiyah Surabaya.
        </h2>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button size="lg" data-testid="final-cta-consult-button" onClick={() => navigate("/kontak")} className="h-12 rounded-full bg-white px-8 text-[#0F6B4F] hover:bg-white/90">
            Konsultasi Sekarang
          </Button>
          <Button size="lg" variant="outline" data-testid="final-cta-register-button" onClick={() => navigate("/register")} className="h-12 rounded-full border-white/40 bg-transparent px-8 text-white hover:bg-white/10">
            Daftar Sebagai Jamaah
          </Button>
        </div>
      </div>
    </section>
  );
}
